import { Box, BoxProps, convertHexToRGBA, Text, TextProps } from '@jfs/ui-new'
import React from 'react'
import { MerchantTheme } from '../../../data/models/Config'
import { useStores } from '../../../data/store'

interface ProgressIndicatorProps {
  data: string[]
  currentStep: number
}

export const ProgressIndicator = ({ data, currentStep }: ProgressIndicatorProps) => {
  const { theme } = useStores((root) => ({
    theme: root?.config?.merchantTheme,
  }))
  return (
    <Box flexDirection={'row'} pl={14}>
      {data.map((item: string, index: number) => {
        return (
          <Box {...styles.container(index !== data.length - 1 ? 1 : undefined)}>
            <Box {...styles.row}>
              <Box {...styles.circle(index === currentStep - 1, theme as any)}>
                <Text {...styles.indexText(index === currentStep - 1, theme as any)}>{index + 1}</Text>
              </Box>
              {index !== data.length - 1 && (
                <Box
                  h={1}
                  f={1}
                  marginHorizontal={8}
                  backgroundColor={convertHexToRGBA(theme.bodyTextColor, 50) as any}
                />
              )}
            </Box>
            <Box ml={-15} mt={6}>
              <Text
                {...styles.item(
                  index === currentStep - 1
                    ? 'jioType-bold'
                    : index === currentStep
                    ? 'jioType-medium'
                    : 'jioType-light',
                  theme as any,
                )}>
                {item}
              </Text>
            </Box>
          </Box>
        )
      })}
    </Box>
  )
}

const styles = {
  container: (flex: number | undefined) =>
    ({
      flexDirection: 'column',
      flex,
    } as BoxProps),
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  } as BoxProps,
  circle: (isSelected: boolean, theme: typeof MerchantTheme.properties) =>
    ({
      borderRadius: 40,
      width: 20,
      height: 20,
      borderWidth: 1,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: (isSelected ? theme.brandColor : theme.bodyBgColor) as any,
      borderColor: theme.brandColor as any,
    } as BoxProps),
  indexText: (isSelected: boolean, theme: typeof MerchantTheme.properties) =>
    ({
      fontSize: 12,
      fontFamily: 'jioType-medium',
      color: (isSelected ? theme.bodyBgColor : theme.brandColor) as any,
    } as TextProps),
  item: (fontFamily: string, theme: typeof MerchantTheme.properties) =>
    ({
      fontSize: 12,
      fontFamily,
      color: theme.bodyTextColor as any,
    } as TextProps),
}
